import React from "react";
import {
  Typography,
  Box,
  Grid,
  List,
  ListItem,
  ListItemButton,
  CardActions,
  IconButton,
  Chip,
} from "@mui/material";
import { MdClose } from "react-icons/md";
import { useHistory } from "react-router-dom";

import * as API from "../../api";
import * as CONST from "../../Constants";
import { PatientData } from "../../Contexts";
import Loading from "../../../../shared/Loading";
import GoogleMapReact from "google-map-react";
import PcpLocationItem from "./PcpLocationItem";
import MapMarker from "./MapMarker";

export default function PcpLocationsList(props) {
  const patient = React.useContext(PatientData);
  const [loading, setLoading] = React.useState(true);
  const [pcps, setPcps] = React.useState(null);
  const [selectedPractice, setSelectedPractice] = React.useState(null);
  const history = useHistory();

  React.useEffect(() => {
    (async () => {
      if (!pcps) {
        let pcpsList = await API.getPcps();
        let practiceLocations = await Promise.all(
          pcpsList.pcp_practices.map(async (practice) => {
            return {
              ...practice,
              location: practice.latitude
                ? { lat: parseFloat(practice.latitude), lng: parseFloat(practice.longitude) }
                : { lat: null, lng: null },
            };
          })
        );
        setPcps(practiceLocations);
        setTimeout(() => setLoading(false), 900);
      }
    })();
  }, []);

  const distanceToMouse = (pt, mp) => {
    if (pt && mp) {
      return Math.sqrt((pt.x - mp.x) * (pt.x - mp.x) + (pt.y - mp.y) * (pt.y - mp.y));
    }
  };

  const mapList = (items) =>
    items.map((practice) => (
      <ListItem key={practice.name} disablePadding sx={{ display: "block" }}>
        <ListItemButton
          onClick={() => {
            history.push(`/patient_portal/practice/${practice.id}`)
          }}
          sx={{ pl: 3, py: 1.5, display: "block" }}
        >
          <PcpLocationItem
            practice={practice}
          />
          <Chip
            className="chip-light"
            label={
              !practice.pcps.length ? CONST.NO_PCPS : practice.electable_active_pcps.length + CONST.PCPS_AVAILABLE
            }
          />
        </ListItemButton>
      </ListItem>
    ));

  return (
    <div className="pcp">
      <CardActions>
        <Box fontSize="25px" color="#24a491" ml={1} fontWeight="600">
          PCP Election Page
        </Box>
        <IconButton
          className="card-button"
          sx={{ ml: "auto", mb: 1, width: "auto", mr: 1 }}
          onClick={(e) => props.cancel()}
          aria-label="cancel"
        >
          <MdClose />
        </IconButton>
      </CardActions>

      {!selectedPractice && (
        <Grid container>
          <Grid item xs={12} className="bt" p={2}>
            <Typography color="#3dad9b">{CONST.PCP_LOCATIONS_HEADER}</Typography>
          </Grid>
          <Grid item xs={12}>
            {loading && <Loading message="loading" />}
            {!loading && (
              <>
                <Box
                  sx={{
                    height: { md: "60vh", xs: "50vh" },
                    width: "100%",
                  }}
                >
                  <GoogleMapReact
                    defaultCenter={
                      patient.latitude
                        ? {
                            lat: parseFloat(patient.latitude),
                            lng: parseFloat(patient.longitude),
                          }
                        : !!pcps.length > 0 && {
                            ...pcps[0].location,
                          }
                    }
                    defaultZoom={11}
                    bootstrapURLKeys={{ key: `${patient.google_maps_api_key}` }}
                    yesIWantToUseGoogleMapApiInternals
                    distanceToMouse={distanceToMouse}
                  >
                    {pcps.map((i, idx) => {
                      return (
                        <MapMarker
                          selectable={true}
                          showPcps={true}
                          selectHandler={() => history.push(`/patient_portal/practice/${i.id}`)}
                          key={idx}
                          lat={i.location.lat}
                          lng={i.location.lng}
                          practice={{ ...i }}
                        />
                      );
                    })}
                  </GoogleMapReact>
                </Box>

                <CardActions className="bb bt">
                  <Typography ml={2} variant="overline">
                    {CONST.OUR_PCP_LOCATIONS}
                  </Typography>
                </CardActions>

                <List disablePadding>{!!pcps.length > 0 && mapList(pcps)}</List>
              </>
            )}
          </Grid>
        </Grid>
      )}
    </div>
  );
}
